import { request } from "../../utils/config"

export const GET_SECTIONS = async () => {
  const response = await request({
    url: `Sections`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
